import PropTypes from "prop-types";

export default PropTypes.shape({
  timeToHireTotalDays: PropTypes.string,
  timeToHire: PropTypes.shape({
    applicationsReceived: PropTypes.shape({
      days: PropTypes.number,
      percent: PropTypes.number,
    }),
    firstInterview: PropTypes.shape({
      days: PropTypes.number,
      percent: PropTypes.number,
    }),
    secondInterview: PropTypes.shape({
      days: PropTypes.number,
      percent: PropTypes.number,
    }),
    offerMade: PropTypes.shape({
      days: PropTypes.number,
      percent: PropTypes.number,
    }),
    offerAccepted: PropTypes.shape({
      days: PropTypes.number,
      percent: PropTypes.number,
    }),
  }),
});
